import React from 'react';

import SvgIcon, { IProps } from '../SvgIcon';

export default (props: IProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M10.9 2.78a2.25 2.25 0 012.98.74l.09.14 7.76 14A2.25 2.25 0 0119.9 21H4.24a2.25 2.25 0 01-2.04-3.19l.07-.14 7.76-14.01c.2-.37.51-.67.88-.88zm9.51 15.62L12.66 4.39a.75.75 0 00-1.26-.1l-.06.1-7.75 14a.75.75 0 00.56 1.11h15.6a.75.75 0 00.7-1.02l-.04-.08z"/>
    <path fill="#FF3A3A" d="M13 17a1 1 0 10-2 0 1 1 0 002 0zM12.74 9.15a.75.75 0 00-1.5.1l.01 4.5v.1a.75.75 0 001.5-.1v-4.5l-.01-.1z"/>
  </SvgIcon>
);